import { useEffect, useState } from "react";
import { User } from "../../user/types";
import { getUserList } from "../api/index";
import { setUsers } from "./DbtDocsReducer";
import {
  useDbtDocsCollaborationDispatch,
  useDbtDocsCollaborationSelector,
} from "./DbtDocsCollaborationProvider";
import { LoadingState } from "./types";

const useConversationUsers = () => {
  const dispatch = useDbtDocsCollaborationDispatch();
  const users = useDbtDocsCollaborationSelector(state =>
    Object.keys(state.users || {})
  ) as User["id"][];

  const [loadingState, setLoadingState] = useState(LoadingState.UNINITIALIZED);

  useEffect(() => {
    if (loadingState !== LoadingState.UNINITIALIZED || Object.keys(users).length) {
      return;
    }
    setLoadingState(LoadingState.LOADING);
    getUserList()
      .then(data => {
        console.log("useConversationUsers", data);
        dispatch(setUsers(data));
      })
      .catch(err => console.error("error while fetching users list", err))
      .finally(() => {
        setLoadingState(LoadingState.INITIALIZED);
      });
  }, [dispatch, loadingState, users]);

  return { isLoading: loadingState === LoadingState.LOADING };
};

export default useConversationUsers;
